import i18n from './vue-i18n';

export default function initAgoWidget(token) {
  window.AGO = {
    basepath: 'https://silae.useago.com/',
    widgetApiKey: 'silae_public_key_AHUIUY678H',
    title: 'Assistant eDocPerso',
    prompt: i18n.t('support.widget.prompt'),
    icon: '/img/support-widget.png',
    colors: {
      button: '#2b627b',
      header: '#2b627b',
    },
    jwt: token,
  };

  const agoFrame = document.createElement('script');

  agoFrame.setAttribute('src', 'https://useago.github.io/widgetjs/frame.js');
  document.head.appendChild(agoFrame);
}
